import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserSync } from './hooks/useUserSync';
import Header from './components/Header';
import SplashPage from './components/SplashPage';
import Dashboard from './components/Dashboard';
import Tutorial from './components/Tutorial';
import BuildAgent from './components/BuildAgent';
import LoadingSpinner from './components/shared/LoadingSpinner';
import ErrorDisplay from './components/shared/ErrorDisplay';
import Leaderboard from './components/Leaderboard';
import About from './components/About';
import MutantC60 from './components/MutantC60';
import Play from  './components/Play';
import AgentProfile from  './components/AgentProfile';
import './App.css';

function App() {
  const { isLoading, error, isAuthenticated } = useAuth0();
  const {
    userData,
    apiError,
    showUsernameForm,
    setShowUsernameForm,
    setUserData
  } = useUserSync();

  if (isLoading) {
    return <LoadingSpinner message="Initializing..." />;
  }

  if (error) {
    return <ErrorDisplay error={error} title="Authentication Error" />;
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Header userData={userData} />

        <main className="App-main">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<SplashPage />} />
              <Route path="/agent/:agentId" element={<AgentProfile />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            {/*<Route path="/mutantc60" element={<MutantC60 />} />*/}
            <Route path="/buildagent" element={<BuildAgent />} />
            <Route path="/about" element={<About />} />
            {/* Protected routes */}
            <Route path="/play" element={
              isAuthenticated ? (
                <Play userData={userData} />  // Pass userData as prop
              ) : (
                <Navigate to="/" replace />
              )
            } />
            <Route path="/dashboard" element={
              isAuthenticated ? (
                <Dashboard
                  userData={userData}
                  apiError={apiError}
                  showUsernameForm={showUsernameForm}
                  onUsernameSet={(updatedUser) => {
                    setUserData(updatedUser);
                    setShowUsernameForm(false);
                  }}
                  onAvatarUpdate={setUserData}
                />
              ) : (
                <Navigate to="/" replace />
              )
            } />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;